export const MAKE_PAYMENT = 'MAKE_PAYMENT';
export const PAYMENT_LOADER = 'PAYMENT_LOADER';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
